import {
  IconMapMetroSpb16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroNN16,
  IconMapMetroMsk16,
  type ISVGIconProps,
} from '@cian/ui-kit-design-tokens/icons';
import type { ComponentType } from 'react';

const METRO_ICONS_BY_REGION: Partial<Record<number, ComponentType<ISVGIconProps>>> = {
  2: IconMapMetroSpb16,
  4743: IconMapMetroEkb16,
  4777: IconMapMetroKzn16,
  4897: IconMapMetroNovosib16,
  4966: IconMapMetroSam16,
  4885: IconMapMetroNN16,
};

export const getUndergroundIcon = (regionId: number) => {
  const IconComponent = METRO_ICONS_BY_REGION[regionId] || IconMapMetroMsk16;

  return <IconComponent color="current_color" />;
};
